module.exports = __webpack_public_path__ + "static/media/popupbg.91001560.png";